<script setup>
import {FormKitSchema, FormKit} from '@formkit/vue';
import {inject} from "vue";

const $t = inject('translator');

const props = defineProps({
  action: String,
  service: String,
})

const schema = [{
  $formkit: 'hidden',
  value: props.service,
  name: 'service',
}, {
  $formkit: 'text',
  name: 'name',
  label: $t('First and last name'),
  labelClass: 'sr-only',
  validation: 'required|length:1,100',
  placeholder: $t('First and last name'),
}, {
  $formkit: 'email',
  name: 'email',
  label: $t('Business email'),
  labelClass: 'sr-only',
  validation: 'required|email|length:1,100',
  placeholder: $t('Business email'),
}];
</script>

<template>
  <FormKit type="form" :action="props.action" method="POST" :submit-label="$t('Continue')">
    <FormKitSchema :schema="schema"/>
  </FormKit>
</template>
